import { render, staticRenderFns } from "./foundational.vue?vue&type=template&id=101fe094&"
import script from "./foundational.vue?vue&type=script&lang=js&"
export * from "./foundational.vue?vue&type=script&lang=js&"
import style0 from "./foundational.vue?vue&type=style&index=0&id=101fe094&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports